export function isEmpty(s : string){
    return s.trim() === "";
}